#import "./flexibleSectionsBigAccordionSections.graphql"

fragment flexibleSectionsBigAccordionItem on flexibleSections_bigAccordionItem_BlockType {
    __typename
    title: plaintext
    prettyID: plaintext2
    children {
        ... flexibleSectionsBigAccordionSections
    }
}
